import { useMutation, useQueryClient } from '@tanstack/react-query';
import { message } from 'antd';
import { I18n } from '@aws-amplify/core';
import { QUERY_KEYS } from '@/utils/query-keys';
import { DataExtractionService } from '@/infra/services/data-extraction';

interface UpdateDataExtractionParams {
	id: string;
	organization_id: string;
	company_id?: string;
	sector_id?: string | null;
	line_id?: string | null;
	workstation_id?: string | null;
	extraction_name?: string;
	start_date?: string | null;
	end_date?: string | null;
	has_action_plan_extraction?: boolean;
	data_extraction_reports?: any;
	ergonomic_tool_ids?: string[];
	custom_report_id?: string | null;
	current_step_sequence?: number;
	select_all_reports?: boolean;
	data_extraction_files?: string[];
	select_all_files?: boolean;
	excluded_files?: string[];
	file_name?: string;
}

const Service = DataExtractionService.getInstance();

export const useUpdateDataExtraction = () => {
	const queryClient = useQueryClient();

	return useMutation({
		mutationFn: async (params: UpdateDataExtractionParams) => Service.update(params),
		onSuccess: () => {
			queryClient.invalidateQueries([QUERY_KEYS.GET_EXTRACTION_FILES_LIST]);
			queryClient.invalidateQueries([QUERY_KEYS.GET_DATA_EXTRACTION_INFINITE_FILES]);
			message.success(I18n.get('Data extraction updated successfully'));
		},
		onError: () => {
			message.error(I18n.get('Error updating data extraction'));
		}
	});
};
